import { Component, ViewChild, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatInput } from '@angular/material/input';
import { Subscription, Subject, forkJoin } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import { EmergenciesstatusService } from './emergenciesstatus.service';
import { Emergenciesstatus } from './emergenciesstatus.model';
import { AuthenticationService } from '../../../service/authentication.service';
import { ApiService } from '../../../service/api.service';
import { UtilsService } from '../../../service/helper/utils.service';
import { HttpClient } from '@angular/common/http';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import Speech from 'speak-tts';
import 'hammerjs';

@Component({
  selector: 'app-emergenciesstatus',
  templateUrl: './emergenciesstatus.component.html',
  styleUrls: ['style.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmergenciesstatusComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('start', { read: MatInput, static: false }) start: MatInput;
  @ViewChild('end', { read: MatInput, static: false }) end: MatInput;

  private subscriptions: Subscription[] = [];
  private filterSubject = new Subject<any>();
  dataSource = new MatTableDataSource<Emergenciesstatus>([]);
  pageSize = 50;
  itemCount = 1000;
  profile = '';
  totplants: string[] = [];
  totalarms: string[] = [];
  filterSelectObj = [
    { name: 'Data/Ora', columnProp: 'timestamp', options: [], modelValue: undefined },
    { name: 'ID impianto', columnProp: 'plant', options: [], modelValue: undefined },
    { name: 'Messaggio', columnProp: 'message', options: [], modelValue: undefined },
    { name: 'SIM', columnProp: 'sim', options: [], modelValue: undefined },
    { name: 'Codice allarme', columnProp: 'code', options: [], modelValue: undefined }
  ];
  
  filterValues = {};
  filter = {};
  displayedColumns: string[] = ['timestamp', 'plant', 'message', 'code', 'actions', 'reset'];
  speech = new Speech();
  worker: Worker | null = null;

  constructor(
    private authenticationService: AuthenticationService,
    private emergenciesstatusService: EmergenciesstatusService,
    private http: HttpClient,
    private storageService: ApiService,
    private utilsService: UtilsService
  ) {}

  async ngOnInit() {
    this.profile = this.authenticationService.currentUserValue.profile;

    this.subscriptions.push(
      this.storageService.getEmergencyColumn().subscribe(v => {
        this.filterSelectObj.forEach(o => {
          if (o.columnProp !== 'timestamp' && o.columnProp !== 'sim') o.options = v[o.columnProp].sort();
        });
      }),
      this.storageService.getPlantsTot().subscribe(v => (this.totplants = v.sort())),
      this.storageService.getAlarmcodesTot().subscribe(v => (this.totalarms = v.sort()))
    );

    await this.speech.init({ volume: 1, lang: 'it-IT', rate: 0.7, pitch: 1 }).catch(() => {});

    this.filterSubject.pipe(debounceTime(500)).subscribe(() => {
      this.getData(0, this.pageSize, this.filter);
    });

    if (typeof Worker !== 'undefined') this.worker = new Worker('./download.worker.js');

    this.getData(0, this.pageSize, []);
  }

  async getData(pageIndex: number, pageSize: number, filter: any) {
    this.utilsService.showLoader();
    try {
      const [count, response] = await forkJoin([
        this.storageService.getEmergenciesstatuscountt().pipe(take(1)),
        this.storageService.getEmergenciesstatus(pageIndex, pageSize, filter).pipe(take(1))
      ]).toPromise();
      this.itemCount = parseInt(count, 10);
      this.dataSource.data = response.data || [];
    } catch (error) {
    } finally {
      this.utilsService.hideLoader();
    }
  }

  updateEnd(end: any) {
    this.filter['end'] = new Date(end._selected._d).getTime();
    this.filterSubject.next();
  }

  updateStart(start: any) {
    this.filter['start'] = new Date(start._selected._d).getTime();
    this.filterSubject.next();
  }

  resetFilters() {
    this.filter = {};
    this.filterValues = {};
    this.filterSelectObj.forEach(value => (value.modelValue = undefined));
    this.dataSource.filter = '';
    if (this.start) this.start.value = '';
    if (this.end) this.end.value = '';
    this.getData(0, this.pageSize, []);
  }

  filterChange(filter: any) {
    this.filter[filter.columnProp] = filter.modelValue;
    this.filterSubject.next();
  }

  async download() {
    this.utilsService.showLoader();
    try {
      const data = await this.storageService.getEmergenciesstatustot().toPromise();
      this.downloadFile(data, 'stato_emergenze');
    } finally {
      this.utilsService.hideLoader();
    }
  }

  downloadFile(data: any, filename = 'data') {
    if (this.worker) this.worker.postMessage({ data, filename });
  }

  ngOnDestroy() {
    if (this.worker) this.worker.terminate();
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
